require('./okDiscountSuccessMessage.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');

// @commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { OKMessage } = require('commonsComponents/OKMessage');

class OkDiscountSuccessMessage extends React.Component {

    buildEmail() {
        const { email } = this.props;

        const strongEmail = (
            <span>
                {`${formatText('OKDiscounts-successMessage1')} `}
                <strong className="okdiscount-success-message__email">
                    {email}
                </strong>
                {` ${formatText('OKDiscounts-successMessage2')}`}
            </span>
        )
        return strongEmail;
    }

    render() {
        const message = this.buildEmail();

        return (
            <div className="okdiscount-success-message">
                <div className="okdiscount-success-message__box-title-container">
                    <div className="okdiscount-success-message__icon-container">
                        <i className="okdiscount-success-message__icon" />
                    </div>
                    <div className="okdiscount-success-message__title">
                        <FormattedText
                            value="OKDiscounts-bodyTitle"
                            className="okdiscount-success-message__body-title"
                        />
                    </div>
                    <div className="okdiscount-success-message__subtitle">
                        <OKMessage type="important">
                            {message}
                        </OKMessage>
                    </div>
                </div>
            </div>
        )
    }
}

OkDiscountSuccessMessage.propTypes = {
    email: PropTypes.string
};

module.exports = OkDiscountSuccessMessage;